// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3K8DaNtrxuq-u3yFuABSfi ._2NET-nQnfX5tAJtwbYCsVw{text-transform:uppercase;font-weight:400}._3K8DaNtrxuq-u3yFuABSfi ._2P7_8no0ilyq97Znv_6aaG{font-weight:600}._3ZfJ3mx2koimQ85li5Ma1r{text-align:right}", "",{"version":3,"sources":["webpack://./resources/js/components/PublicCode/styles.module.scss"],"names":[],"mappings":"AACI,kDACI,wBAAA,CACA,eAAR,CAEI,kDACI,eAAR,CAIA,yBACI,gBADJ","sourcesContent":[".public_code {\n    .pc_text {\n        text-transform: uppercase;  \n        font-weight: 400;\n    }\n    .pc_val {\n        font-weight: 600;\n    }\n}\n\n.align_right {\n    text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"public_code": "_3K8DaNtrxuq-u3yFuABSfi",
	"pc_text": "_2NET-nQnfX5tAJtwbYCsVw",
	"pc_val": "_2P7_8no0ilyq97Znv_6aaG",
	"align_right": "_3ZfJ3mx2koimQ85li5Ma1r"
};
export default ___CSS_LOADER_EXPORT___;
